import { useGetQuery } from "../hooks";
import { useDataContext } from "../contexts";
import Form from "./Form";
import { getTransactionFields } from "../utils";

export default function TransactionEdit({ callback, id }) {
  const { memberUsers } = useDataContext();

  const transactionsQuery = useGetQuery("transactions", {
    identifier: id,
  });

  if (transactionsQuery.isLoading) {
    return null;
  }

  if (!transactionsQuery.data) {
    return "Transaction not found";
  }

  return (
    <Form
      path="transactions"
      id={id}
      method="PATCH"
      submitCallback={callback}
      initialValues={transactionsQuery.data}
      fields={getTransactionFields(memberUsers)}
    />
  );
}
